<div class="request-customfield-container">
	<div class="header-wrap">
		<span class="tab" [ngClass]="{ selected: selectedCustomfield == undefined }" (click)="selectedCustomfield = undefined">{{
			labels.lbl_geral_campos_customizados
		}}</span>
		<span class="tab" [ngClass]="{ selected: selectedCustomfield != undefined }" *ngIf="selectedCustomfield != undefined">{{
			selectedCustomfield.name
		}}</span>
	</div>
	<div class="body-wrap">
		<ng-container *ngIf="selectedCustomfield == undefined">
			<div class="form-wrap">
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_nome }}</span>
					<input [value]="searchName" (input)="searchName = $event.target.value" />
				</div>

				<!-- <pcp-request-classification
                [initOn]="'solutionArea'"
                [isEditingClassification]="classificationOptions.isEditingClassification"
                [alertField]="classificationOptions.alertField"
                [hideField]="classificationOptions.hideField"
                [customerList]="classificationOptions.selectedCustomer"
                [requiredField]="classificationOptions.requiredField"
                (getClassification)="setClassification($event, 'searchClassification')">
                </pcp-request-classification> -->

				<pcp-request-classification-reverse-rmk
					[alertField]="classificationOptions.alertField"
					[idCustomerList]="classificationOptions.selectedCustomer"
					[hideField]="classificationOptions.hideField"
					(getClassification)="setClassification($event, 'searchClassification')">
				</pcp-request-classification-reverse-rmk>

				<div class="button-container">
					<div class="button" (click)="addNewCustomfield()">{{ labels.lbl_geral_novo }}</div>
					<div class="button" [ngClass]="{ disabled: isLoadingCustomfields }" (click)="searchCustomfields()">
						{{ labels.lbl_geral_buscar }}
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isLoadingBounceCustomFields"></cpi-dot-bounce-loading-effect>
					</div>
				</div>
			</div>

			<cpi-msp-table
				[header]="requestViewItems"
				[body]="customfieldArr"
				[height]="'33dvh'"
				[labels]="labels"
				[insideSort]="true"
				[tableOnly]="true"
				(getSelectedItem)="selectCustomfield($event)"
				(getSelectedItemIndex)="selectedIndex = $event"
				*ngIf="customfieldArr.length > 0">
			</cpi-msp-table>
		</ng-container>

		<ng-container *ngIf="selectedCustomfield != undefined">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_nome }}</span>
				<input [value]="selectedCustomfield.name" (input)="selectedCustomfield.name = $event.target.value" />
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_tipo_do_campo }}</span>
				<select (change)="changeFieldType(selectedCustomfield, $event.target.value)">
					<option [value]="'Textarea'" [selected]="selectedCustomfield.inputType === 'Textarea'">
						{{ labels.lbl_geral_caixa_texto }}
					</option>
					<option [value]="'Text'" [selected]="selectedCustomfield.inputType === 'Text'">{{ labels.lbl_geral_texto }}</option>
					<option [value]="'Select'" [selected]="selectedCustomfield.inputType === 'Select'">
						{{ labels.lbl_geral_selecao }}
					</option>
					<option [value]="'Multi-Select'" [selected]="selectedCustomfield.inputType === 'Multi-Select'">
						{{ labels.lbl_geral_selecao_multipla }}
					</option>
					<option [value]="'Select-Approver'" [selected]="selectedCustomfield.inputType === 'Select-Approver'">
						{{ labels.lbl_geral_selecao_aprovadores }}
					</option>
					<option [value]="'Radio'" [selected]="selectedCustomfield.inputType === 'Radio'">Radio</option>
					<option [value]="'Checkbox'" [selected]="selectedCustomfield.inputType === 'Checkbox'">Checkbox</option>
					<option [value]="'Attachment'" [selected]="selectedCustomfield.inputType === 'Attachment'">
						{{ labels.lbl_geral_anexo }}
					</option>
					<option [value]="'json_dynamic'" [selected]="selectedCustomfield.inputType === 'json_dynamic'">JSON Dinâmico</option>
				</select>
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_mandatory }}</span>
				<cpi-checkbox
					[value]="selectedCustomfield.required"
					(oValue)="selectedCustomfield.required = $event"
					[innerText]="selectedCustomfield.required == true ? labels.lbl_geral_sim : labels.lbl_geral_nao">
				</cpi-checkbox>
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_visivel_apenas_para_analistas }}</span>
				<cpi-checkbox
					[value]="selectedCustomfield.analystView"
					(oValue)="selectedCustomfield.analystView = $event"
					[innerText]="selectedCustomfield.analystView == true ? labels.lbl_geral_sim : labels.lbl_geral_nao">
				</cpi-checkbox>
			</div>

			<div class="dotted-input-container" *ngIf="selectedCustomfield.inputType !== 'Select-Approver'">
				<span>{{ labels.lbl_geral_ocultar }}</span>
				<cpi-checkbox
					[value]="selectedCustomfield.hidden"
					(oValue)="selectedCustomfield.hidden = $event"
					[innerText]="selectedCustomfield.hidden == true ? labels.lbl_geral_sim : labels.lbl_geral_nao">
				</cpi-checkbox>
			</div>

			<div class="dotted-input-container" *ngIf="selectedCustomfield.inputType !== 'Select-Approver'">
				<span>{{ labels.lbl_status_desativado }}</span>
				<cpi-checkbox
					[value]="selectedCustomfield.disabled"
					(oValue)="selectedCustomfield.disabled = $event"
					[innerText]="selectedCustomfield.disabled == true ? labels.lbl_geral_sim : labels.lbl_geral_nao">
				</cpi-checkbox>
			</div>

			<div
				*ngIf="
					selectedCustomfield.inputType === 'Select' ||
					selectedCustomfield.inputType === 'Multi-Select' ||
					selectedCustomfield.inputType === 'Radio' ||
					selectedCustomfield.inputType === 'Checkbox'
				">
				<cpi-generic-form-gen [setGenericForm]="selectedCustomfield.items" [columns]="1" [labels]="labels"> </cpi-generic-form-gen>
			</div>

			<div class="form-wrap">
				<span>{{ labels.lbl_campos_customizados_aparecerao_determinadas_classificacoes }}</span>

				<pcp-request-classification-reverse-rmk
					[alertField]="classificationOptions.alertField"
					[hideField]="classificationOptions.hideField"
					[idCustomerList]="classificationOptions.selectedCustomer"
					(getClassification)="setClassification($event, 'selectedClassification')">
				</pcp-request-classification-reverse-rmk>

				<div class="button-container">
					<div class="button" (click)="addClassification()">{{ labels.lbl_geral_adicionar }}</div>
				</div>

				<div class="form-wrap" *ngIf="selectedCustomfieldClassification.length > 0">
					<span>{{ labels.lbl_classificacoes_salvas }}</span>
					<div class="classification-line" *ngFor="let classificationLine of selectedCustomfieldClassification; let i = index">
						<span
							>{{ classificationLine.category[0]?.name }} > {{ classificationLine.topic[0]?.name }} >
							{{ classificationLine.solutionArea[0]?.name }}</span
						>
						<span
							(click)="
								confirmDeleteClassification.classList.contains('confirmClick')
									? deleteClassification(i)
									: confirmButton(confirmDeleteClassification)
							"
							#confirmDeleteClassification
							><fa-icon [icon]="icons.faTrash"></fa-icon
						></span>
					</div>
				</div>

				<div
					class="form-wrap"
					*ngIf="
						selectedCustomfieldClassification.length > 0 &&
						selectedCustomfield.inputType === 'Select-Approver' &&
						!isLoadingTasks
					">
					<span>{{ labels.lbl_chamado_tarefa }}</span>
					<span *ngIf="tasks.length === 0 && selectedCustomfieldClassification.length > 0" class="classification-line">{{
						labels.lbl_geral_classificacao_sem_tarefa_relacionada
					}}</span>
					<select
						id="task"
						name="task"
						[(ngModel)]="selectedTask"
						*ngIf="selectedCustomfield.inputType === 'Select-Approver' && tasks.length > 0">
						<option [value]="''" selected>{{ labels.lbl_geral_selecione }}</option>
						<option *ngFor="let task of tasks" [value]="task.id">{{ task.taskId }} - {{ task.task }}</option>
					</select>
				</div>
			</div>

			<div class="button-container">
				<div class="button" (click)="selectedCustomfield = undefined; isLoadingCustomfields = false">
					{{ labels.lbl_geral_voltar }}
				</div>
				<div
					class="button"
					(click)="
						confirmDeleteField.classList.contains('confirmClick') ? deleteCustomfield() : confirmButton(confirmDeleteField)
					"
					#confirmDeleteField>
					{{ labels.lbl_geral_excluir }}
				</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdatingCustomfield }"
					(click)="createCustomfield()"
					*ngIf="selectedCustomfield.id === '-1'">
					{{ labels.lbl_geral_salvar }}
					<cpi-dot-bounce-loading-effect
						[color]="'var(--const-white)'"
						*ngIf="isUpdatingCustomfield"></cpi-dot-bounce-loading-effect>
				</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdatingCustomfield }"
					(click)="updateCustomfield()"
					*ngIf="selectedCustomfield.id != '-1'">
					{{ labels.lbl_geral_salvar }}
					<cpi-dot-bounce-loading-effect
						[color]="'var(--const-white)'"
						*ngIf="isUpdatingCustomfield"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</ng-container>
	</div>
</div>
